import React, { FC, ReactNode } from "react";
import { ActionsGroup } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { useDialogReset } from "../../../hooks/useDialogs";
import { useDialogContext } from "./FullScreenDialog";

import {
  ApplyButton,
  BackButton,
  CancelButton,
  DialogActions as DialogActionsContainer,
  DialogActionsContentContainer,
} from "./styled";

export interface DialogActionsProps {
  onApply?: VoidFunction;
  applyDisabled?: boolean;
  centered?: boolean;
  children?: ReactNode;
  applyText?: string;
  isWaiting?: boolean;
  backButtonText?: string;
  onBackButton?: VoidFunction;
  cancelButtonText?: string;
  onCancel?: VoidFunction;
  displayShadow?: boolean;
  childrenBefore?: boolean;
}

export const DialogActions: FC<DialogActionsProps> = ({
  centered,
  onApply,
  applyDisabled,
  applyText,
  isWaiting,
  children,
  backButtonText,
  onBackButton,
  cancelButtonText,
  onCancel,
  displayShadow,
  childrenBefore,
}) => {
  const { t } = useTranslation("common");
  const cancelDialog = useDialogReset();
  const { applyText: applyTextContext } = useDialogContext();

  return (
    <DialogActionsContainer showShadow={displayShadow}>
      {childrenBefore && children}
      <DialogActionsContentContainer>
        <ActionsGroup style={{ width: "100%", justifyContent: centered && "center", alignItems: "center" }}>
          <ApplyButton isWaiting={isWaiting} disabled={applyDisabled} primary onClick={onApply || cancelDialog}>
            {applyText || applyTextContext}
          </ApplyButton>
          {onBackButton && <BackButton onClick={onBackButton}>{backButtonText || t("actions.back")}</BackButton>}
          <CancelButton onClick={onCancel || cancelDialog}>{cancelButtonText || t("actions.cancel")}</CancelButton>
          {!childrenBefore && children}
        </ActionsGroup>
      </DialogActionsContentContainer>
    </DialogActionsContainer>
  );
};
